export const constantsMixin = {
    data: function () {
        return {
            gmbConstants: {
                noFilterOptionColor: "black", // Because grey color is almost invisible on map
                noFilterOptionLabel: "Inconnu",
                noFilterOptionSlug: "NO_VALUE",
            },
        };
    },
    methods: {},
};
